import {
  BooleanFilterKeys,
  DateRangeFilterItem,
  FiltersData,
  ListFilterKeys,
  SectionFilterKeys,
  SortDirection,
  TreeFilterKeys,
  TreeInputData,
} from '../model';

const updateTree = (inputData: TreeInputData[]): TreeInputData[] => {
  const items = inputData.map((item) => ({
    ...item,
    selected: item.isDefault ?? false,
    data: item.data ? updateTree(item.data) : undefined,
  }));
  return items;
};

export const clearSelectedFilters = (filters: FiltersData): FiltersData => {
  const {
    booleanFilter = {},
    listFilter = {},
    sectionFilter = {},
    treeFilter = {},
    sortFilter: appliedSort = {},
    dateRange: appliedDateRange,
  } = filters;

  const sortFilter = Object.fromEntries(
    Object.entries(appliedSort).map(([key, value]) => [
      key,
      {
        ...value,
        selected: (value?.isDefault ?? false) as SortDirection | false,
      },
    ])
  );
  let dateRange: DateRangeFilterItem | undefined = undefined;
  if (appliedDateRange && appliedDateRange.defaultRange) {
    const { startDate, endDate } = appliedDateRange.defaultRange;
    dateRange = {
      startDate,
      endDate,
      defaultRange: appliedDateRange.defaultRange,
    };
  }

  for (const item in booleanFilter) {
    const filterKey = item as BooleanFilterKeys;
    if (booleanFilter[filterKey]) {
      booleanFilter[filterKey] = false;
    }
  }

  for (const item in listFilter) {
    const filterKey = item as ListFilterKeys;
    if (listFilter[filterKey]) {
      const listFilterItems = listFilter[filterKey].value || [];
      const items = listFilterItems.map((x) => ({
        ...x,
        selected: x.isDefault ?? false,
      }));
      listFilter[filterKey].value = items;
    }
  }

  for (const item in sectionFilter) {
    const filterKey = item as SectionFilterKeys;
    if (sectionFilter[filterKey]) {
      const sectionFilterItems = sectionFilter[filterKey]?.value || [];
      const items = sectionFilterItems.map(({ title, data }) => ({
        title,
        data: data.map((x) => ({ ...x, selected: x.isDefault ?? false })),
      }));
      sectionFilter[filterKey].value = items;
    }
  }

  for (const item in treeFilter) {
    const filterKey = item as TreeFilterKeys;
    if (treeFilter[filterKey]) {
      const treeFilterItem = treeFilter[filterKey].value || [];
      const items = updateTree(treeFilterItem);
      treeFilter[filterKey].value = items;
    }
  }

  return {
    booleanFilter,
    listFilter,
    sectionFilter,
    treeFilter,
    sortFilter,
    dateRange,
  };
};
